import { useCallback } from 'react';
import { authApi } from '../api';

/** Sends a lightweight heartbeat to keep sliding session renewed. */
export const useHeartbeat = () => {
  const ping = useCallback(async () => {
    try { await authApi.heartbeat(); } catch {}
  }, []);
  return { ping };
};
